import { trackSavingBuildingEvent } from 'client/shared/saving_analytics';
import { saveBuilding, unsaveBuilding, isBuildingSaved } from './saved_buildings_cookie';

export default class SaveButton {
  constructor(buildingUuid, filledSelector, emptySelector) {
    this.saveButton = document.querySelector('#save-button');

    if (this.saveButton) {
      this.heartFilled = document.querySelector(filledSelector);
      this.heartEmpty = document.querySelector(emptySelector);
      this.activated = isBuildingSaved(buildingUuid); // true = red heart, false = empty heart
      this.uuid = buildingUuid;
      this.toggleBuildingSaved = this.toggleBuildingSaved.bind(this);

      this.saveButton.addEventListener('click', this.toggleBuildingSaved);
      this.toggleHeartIcon();
    }
  }

  toggleBuildingSaved() {
    // What status did we have when the button was clicked?
    const initialStatus = this.activated;

    if (initialStatus) {
      // We were already saved, we must unsave
      unsaveBuilding(this.uuid);
      this.activated = false;
    } else {
      // We were not saved, we must save
      // NOTE: If the cookie does not exist, it will be created right now
      saveBuilding(this.uuid);
      this.activated = true;
    }

    this.toggleHeartIcon();
    trackSavingBuildingEvent(initialStatus, this.uuid);
  }

  toggleHeartIcon() {
    if (this.activated) {
      this.heartFilled.classList.remove('hidden');
      this.heartEmpty.classList.add('hidden');
    } else {
      this.heartEmpty.classList.remove('hidden');
      this.heartFilled.classList.add('hidden');
    }
  }
}
